import { FamousInvestorStatus } from "../services/famous-investor-status";

export const getInvestorLists = (data: FamousInvestorStatus["data"]) => {
  if (!data) return [];
  return data.map((investorData) => ({
    investorName: investorData[0].investorName,
    isDisable:
      investorData
        .slice(1)
        .findIndex((data) => data.units !== "-" || data.unitsPct !== "-") ===
      -1,
  }));
};

export type InvestorLists = ReturnType<typeof getInvestorLists>;
